
var english = {
    ////First Screen
    landing_welcome: 'Welcome!'
    , hello_title: 'Hi'
    , btn_login: "Sign In"
    , btn_cancel: 'Cancel'
    , btn_send_opt: "Request One-Time-Password"
    , btn_register: "Register"
    , btn_submit: 'Submit'
    , btn_save: 'Save'
    , btn_process: "Proceed"
    , btn_next: 'Next'
    , btn_done: 'Done'
    , btn_continue: 'Continue'
    , btn_edit: 'Edit'
    , btn_apply: 'Apply'
    , btn_new_address: "+ New Address"
    , landing_loyalty: "CRM.COM Release App"
    , btn_pay:"Pay"
    //Forgot password
    , forgot_password: 'Forgot Password'
    , forgot_password_desc: 'Input your registered email and we will send you an email with instructions to reset your password.'
    ///Register Screen
    , first_name: 'First Name'
    , last_name: 'Last Name'
    , email: 'Email Address'
    , gender: 'Gender'
    , name_day: "Name Day"
    , language: 'Language'
    , female: 'Female'
    , male: 'Male'
    , date_of_birth: "Date of Birth"
    , name_day: "Name Day"
    , password: "Password"
    , confirm_password: 'Confirm Password'
    , profile_detail: 'Profile Details'
    , register_introduction: "Please enter your details below and tap Register to continue."
    , phone_number: 'Mobile Number'
    , do_you_have_account: "Not registered yet?"
    , enter_your_phone_number: "Enter mobile number"
    , enter_your_firstname: "Enter first name"
    , enter_your_lastname: "Enter last name"
    , email_input_placeholder: "Enter email address"
    , confirm_password_placeholder: "Confirm password"
    , already_account: "Already registered? "
    , exits_rewards_participant: 'Are you an existing rewards participant?'
    , yes: 'Yes'
    , no: 'No'
    , receive_marketing_information: 'Receive marketing information via:'
    , referral_code: 'Refer a Friend Code'
    , resend_email_verification:'Resend verification email'
    , verify_email_desc:'An email was sent to '
    , verify_email_desc_2:' for verification. Follow the instructions in the email to verify your account.'
    //OTP Screen
    , resend_code: 'Resend OTP'
    , verify_introduction_1: "An SMS with a OTP has been sent to "
    , verify_introduction_2: ". Please enter OTP for verification."
    , term_and_conditions_upper: "Terms & Conditions"
    , term_and_conditions_pre: " I agree with the "
    , authenticate: "Authenticate"
    , authenticate_and_sign_in: "Authenticate & Sign In"
    , otp_title: 'An OTP has been sent to '
    , otp_title2: '. Enter the password to authenticate.'
    , an_sms: 'An SMS '
    , an_email: 'An Email '
    , warning_message_agree:'You must agree with the Terms & Conditions and Privacy Policy in order to register.'
    , resend_verification_email: 'Resend verification email'
    , otp_desc: 'An OTP is sent to your email. Please enter the password to authenticate'
    //Login Screen
    , dont_have_account: "Have not registered yet? "
    , user_name: 'Username'
    , password: 'Password'
    , enter_your_username: 'Enter username'
    , enter_your_password: 'Enter password'
    , select_favourite_store_desc:"Select your favorite store"

    //Request permission
    , allow_location_title: 'Allow '
    , allow_location_title_2: " to access this device's location?"
    , allow_all_time: 'Allow all the time'
    , allow_only_use: 'Allow only while the app is in use'
    , deny: 'Deny'

    //Bottom Tab
    , home_title: 'Home'
    , offers_title: "Offers"
    , merchants_title: "Partners"
    , spend_title: "Cashback"
    , profile_title: "Profile"
    , order_title: 'Orders'
    , map_title:'Map'
    , subcriptions_title: 'Subscriptions'
    , online_shop_title: 'Online Shops'
    //Home
    , overview: "Overview"
    , add_a_card: 'Add a Card'
    , add_a_card_suggest: 'Register a valid bank card to pay for orders via the app.'
    , add_a_card_suggest_rewards:'Register a valid bank card and your purchases will be automatically awarded.'
    , wallet_balance: "Wallet Balance"
    , my_wallet: 'Your Wallet'
    , spend_condition: 'Spend Conditions'
    , any_where: "Open Balance"
    , special_condition: "Commerce Balance"
    , my_units: "Your Units"
    , you_have: "You have "
    , units: " units."
    , target_unit: "You need an additional "
    , target_unit_2: " units by "
    , target_unit_3: " to reach the "
    , target_unit_3_b: " to remain in the "
    , target_unit_4: " tier."
    , order_online: "Order Online Now!"
    , delivery: "Delivery"
    , pickup: "Pick Up"
    , direct_sale: "Direct Sale"
    , my_current_location: "Your Location"
    , current_location: "Your Location"
    , set_current_location: "Set current location"
    , pickup_location: 'Pick Up Location'
    , reward_tier: "Your Reward Tier"
    , recommended_offers: 'Featured Offers'
    , barcode: 'Barcode'
    , weekly_cashback: "Weekly Cashback"
    , explorer_more: 'Explore More!'
    //Offer screen
    , search_for: "Search for ..."
    , filter: "Filters"
    , industries: "Industries"
    , industry_sectors: "Industry Sectors"
    , location: "Location"
    , locations: "Locations"
    , tags: "Tags"
    , offer_detail_title: "Offer Details"
    , view_more: 'View More'
    , search_area: 'Google Search'
    , town_city: "Town/City"
    //Profile
    , my_profile: "Profile"
    , my_account: "Account"
    , notifications: "Notifications"
    , logout: "Logout"
    , cards: "Cards"
    , my_cards: "Your cards for rewards"
    , my_cards_orders: "Your Cards for Orders"
    , my_cards_rewards: "Your Cards for Rewards"
    , participating_schemes: "Participating Schemes"
    , transactions: "Transactions"
    , participate_in: 'Schemes that I participate in'
    , join_more_schemes: 'Join more Schemes'
    , join_a_scheme: 'Join a Scheme'
    , refer_a_friend: 'Refer a Friend'
    , referred_friends: 'Referred Friends'
    , refer_a_friend_title: "Everything is better with friends."
    , refer_a_friend_desc: 'Invite your friends to the '
    , refer_a_friend_desc2: ' and get awarded. Do not forget to share your code with them as it is needed during sign-up.'
    , refer_a_friend_intro: 'Send your code via email and phone.'
    //, refer_a_friend_email: 'Specify emails/phones (comma separated)'
    , rewards_transactions: 'Transaction History'
    , order_history: 'Order History'
    , wallet_journals: 'Wallet Journals'
    , wallets: "Wallets"
    , payment_method: "Payment Methods"
    , spending_preferences: "Spend Preferences"
    , address_book: "Your Addresses"
    , select_from_the_list: "Select from the list"
    , change_password: "Change Password"
    , new_password: 'New Password'
    , confirm_new_password: 'Confirm New Password'
    , prefered_order: 'Favorite Location for Ordering'
    , prefered_rewards: 'Favorite Location'
    , id_number: 'ID Number'
    , enter_id_number: 'Enter ID Number'
    , passport_number: 'Passport Number'
    , enter_passport_number: 'Enter Passport Number'
    , statutory_number : 'Statutory Number'
    , enter_statutory_number : 'Enter Statutory Number'
    // Image picker
    , open_settings: 'Open settings'
    , take_a_photo: 'Take a picture'
    , from_gallery: 'From Gallery'
    // Address
    , new_address_title: 'Add Address'
    , edit_address_title: 'Edit Address'
    , select_address: 'Select Address'
    , type: 'Type'
    , address_line: 'Address line'
    , address_line_suggest:'(Building, Floor, Flat #)'
    , city: 'City'
    , postal_code: 'Postal Code'
    , state: "State/Province"
    , country: "Country"
    , set_as_primary: "Set as primary address"
    , address_name: "Address Label"
    , please_select_address: 'Search for an address and select it or click the address location on the map'

    // Home
    , total_cashback: 'Total Cashback Awarded'
    , recent_cashback: 'Recent Cashback Awarded'
    , allotment_title: "Your Wallet Balance"
    , allotment_desc: "Open Balance is money added to your wallet via top-up and is not subject to spend conditions. Commerce Balance is accumulated cashback from your awards and promotions and can be spent when purchasing. Your Commerce Balance spend conditions are as follows:"
    , allotment_condition: "The amount can be spent "
    , on: "on "
    , and: "and "
    , at: "at "
    , between: "between "
    , any_day: "any day "
    , any_time: "any time "
    , all_locations: "all locations"
    , the_following_venues: 'the following locations'
    // Transaction
    , purchase_amount: "Purchase Amount"
    , award_amount: "Award Amount"
    , spend_amount: "Spend Amount"
    , discount_amount: "Discount Amount"
    , rewards_breakdown: 'Rewards Breakdown'
    , total_award_amount: 'Total Award Amount:'
    , spend_on_request_amount: 'Spend on Request Amount:'
    , instant_discount_amount: 'Instant Discount Amount:'
    , automatic_spend_amount: 'Automatic Spend Amount:'
    , applied_fees: 'Applied Fees'
    , total_fee_amount: 'Total Fee Amount:'
    , fee_on_awards: 'Fee on Awards:'
    , fee_on_spend: 'Fee on Spend:'
    , ad_hoc_return: 'Ad Hoc Return'
    , requested_return_amount: 'Requested Return Amount:'
    , actual_return_amount: 'Actual Return Amount:'
    , requested_on: 'Requested on:'

    //Wallet Journals
    , reward_event: 'Reward Event'
    , reward_event_amout: 'Amount'
    , reward_event_spend_method: 'Spend method'
    , reward_event_state: 'State'
    , reward_event_date: 'Date'
    , reward_event_offer_name: 'Offer name'
    , spend_method_on_request: 'On Request'
    , spend_method_instant : 'Instant Discount'
    , spend_method_automatic : 'Automatic Spend'

    , financial_event: 'Financial Event'
    , financial_event_number: 'Event number'
    , financial_event_reference_number: 'Event reference'
    , financial_event_life_cycle_state: 'Event life cycle state'
    , financial_event_date: 'Date'
    , financial_event_amount: 'Amount'
    , financial_event_top_up: 'TOP UP'
    , financial_event_transfer: 'TRANSFER'
    , financial_event_order: 'ORDER'
    , pass_redeemed: 'PASS REDEEMED'

    , wallet_fee: 'Wallet Fees'
    , wallet_fee_name: 'Fee name'
    , wallet_fee_type: 'WALLET FEES'

    , journal_order: 'Order'
    , journal_order_number: 'Number'
    , journal_order_total_cost: 'Total cost'
    , journal_order_submitted_on: 'Submitted on'
    , journal_order_fulfilled_by: 'Fulfilled by'

    
    // Order Service
    , per: "per"
    , TAX_INCLUSIVE: "Tax Inclusive"
    , TAX_EXCLUSIVE: "Tax Exclusive"
    , tax_model_desc:"Termed period covers "
    , tax_model_desc_1: " billing cycle"
    , auto_renewed:"Auto renewed at end of of termed period"
    , no_contract_period:"No Contract Period"
    , no_trial_period:"No Trial Period"
    , trial_period:"trial period"
    , contract_period:"contract period"

    //MoreInfo
    , about_title: 'About the App'
    , privacy_title: 'Privacy Policy'
    , contact_us_title: 'Contact us'
    , faq_title: 'FAQs'
    , term_condition_title: 'Terms & Conditions'

    //Setting
    , setting_title: "Settings"
    , allow_notifications: "Allow Notifications"
    , marketing_information: "Marketing information"
    , marketing_information_desc: "I would like to receive advertising information about offers and other material related to the "
    , marketing_information_desc_2: " via:"
    , marketing_information_request: "Would you like to receive advertising information about offers and other material related to the "
    , marketing_information_request2: " application?"
    , marketing_information_sure: "Sure"
    , marketing_information_no: "No"
    , setting_email: 'Email'
    , setting_sms: 'SMS'
    , setting_allow_geo_tracking: 'Allow Locations'
    , setting_language: 'Language'

    //Orders
    , order_promotion: 'Promotions'
    , order_method: 'Place Your Order:'
    , order_my_orders: 'My Recent Orders'
    , order_select_address: 'Select Address'
    , order_select_store: 'Select Location'
    , my_address: 'Your Addresses'
    , change_store: "Change Location"
    , change_merchant: "Change Location"
    , add_to_cart: 'Add to Cart'
    , add_to_cart_desc: 'Add a valid bank card and use it to pay for your delivery or pick up orders. '

    , update_cart: 'Update'
    , remmove_cart: 'Remove Item'
    , cart: "Cart"
    , award_point: "Award Points"
    , you_will_spend: "you will spend "
    , you_will_have: "you will have "
    , you_will_earn: "you will earn "
    , point: "points"
    , total: "Total"
    , add_notes: "Add Additional Notes"
    , add_your_note: "Additional Notes"
    , note_place_holder: "Type here"
    , notes: 'Notes:'
    , place_order: "Place Order"
    , about_order: "Order preview:"
    , delivery_to: "Deliver to"
    , expected_delivery_time: "Expected Delivery Time"
    , expected_preparation_time: "Expected Preparation Time"
    , expected_pickup_time: "Expected Pick Up time"
    , pick_up_time: "Pick Up Time"
    , nearby_pickup_location: "Nearby Pick Up Locations"
    , including_preparation_time: "including the preparation time"
    , order_to_be_fulfilled_by: "Fulfilled by"
    , select_payment_method: "Select Payment method"
    , select_your_card: "Select card"
    , paypal: "PayPal"
    , cards: "Cards"
    , cash: "Cash"
    , wallet: "Wallet"
    , your_wallet: "You have "
    , your_wallet_2: " in your wallet"
    , placing_your_order: 'Placing your order'
    , take_away_from: 'Pick Up from'
    , delivery_from: 'Deliver to'
    , ready_in: 'Ready in'
    , order_number: 'Order Number'
    , order_placed: 'Order Submitted'
    , select_store: 'Select Location'
    , change: 'Change'
    , warning:'Warning'
    , warning_leave_cart:'You are about to leave the Cart. Do you want to continue?'
    , use_funds_from_wallet:"Use Wallet Funds"
    , to_be_paid_with_funds:"Wallet Funds Amount"
    , amount_due:"Amount Due"
    , consider_an_upgrade: "Consider an Upgrade"
    , your_order:"Your Order"
    , Tap_here_to_continue: 'Click here to continue'
    , Cash_on_delivery: 'Cash on delivery'
    , Cash_on_pikup: 'Cash on pickup'
    , Please_check_cash: 'Please check that you have the exact amount of cash'
    , Please_check_card: 'Please check that you have the exact amount of card'
    , promotion_discount: 'Promotion Discount'
    , sub_total: 'Sub Total'
    , recommendations: 'Recommendations'
    , reorder: 'Reorder'
    , order_items:'Order Items'
    , manage_card: 'Change Card'
    , order_catalogues:'Order Catalogues'
    //Referral code
    , referral_code_title: 'Refer a Friend Code'
    , referral_code_placeholder: 'Enter Refer a Friend code'
    , referral_code_info: 'Did you receive an invitation from a friend?'
    , referred_code_require: 'Enter invitation code below.'
    , skip: 'Skip'
    , referral_code2: 'Referral Code'
    , refer_emails:'Emails'
    , refer_phones:'Phones'
    , refer_a_friend_email: 'Specify emails (10 max)'
    , refer_a_friend_phone: 'Specify phone numbers (10 max)'
    //Identify
    , identify_title: 'Help us identify you'
    , select_identify: 'Select method of identification'
    , loyalty_card: 'Loyalty Card Number'
    , receive_one_time_password: 'Receive OTP for verification via registered:'
    , card_input_placeholder: 'Enter card number'
    , auth_credentinal: 'Enter a valid '
    , auth_credentinal_2: ' to be used as sign-in credentials to the '
    , auth_credentinal_email: 'email address and password'
    , auth_credentinal_phone: 'phone number'
    //Service Owner
    , service_owner_home: 'Homepage'
    , participating_shop: 'Search'
    , request_to_join: 'Request to join a loyalty scheme'
    , join_place_confirm: "Would you like to participate in the "
    , loyalty_scheme: " loyalty scheme"
    , manually_option: "Or enter card details manually"
    , scan: 'Scan'
    , card_number: 'Card Number'
    , enter_card_number: "Enter Card Number"
    , spend_setting: 'Spend Settings'
    , spend_setting_intro: 'Specify how the awards will be automatically spent'
    , start_spending: 'Spend when my minimum wallet balance is'
    , allowed_amount: 'and minimum purchase amount is'
    , enter_amount: 'Enter amount'
    , request_to_sign_off: 'Request to sign out from loyalty scheme'
    , sign_off_merchant_message: "You are about to sign out from "
    , sign_off_merchant_message_2: ". If you proceed you will lose any awarded cashback from this loyalty scheme."
    , sign_off_success_part1: "Sign out of "
    , sign_off_success_part2: " was successful"
    , search_for_shop: 'Search for a loyalty scheme'
    , search_for_shop_suggest_text: 'Search for a loyalty scheme. Type at least 3 characters to search.'
    
    //Spending preferfence
    , automatic_spend:"Automatic Spend Preferences"
    , one_time_password_spend_request:"One Time Password Spend Request"
    , automatic_spend_info:"Enable automatic spend to provide your automatic spend preferences"
    , one_time_password_spend_request_info:"No OTP Spend Request has been found"
    , enable_automatic_spend:"Enable automatic spends?"
    , request_otp_spend_title:"Request an One Time Password for spending on your next purchase"
    , request_otp_spend_amount:"Requested Spend Amount"
    , request_otp_no_spend_amount:"No spend amount restriction is specified"
    , request_otp_spend_suggest:"(leave blank to spend as much as possible)"
    , request_otp:"Request OTP"
    , otp_expires:"OTP expires"
    , and_purchase_at:'and purchase at'
    , select_merchant_to_spend:"Select on which Merchants you wish to spend"
    , spend_setting_merchant_intro: 'Specify on which merchant awards will be automatically spent (only once)'
    
    //Topup Wallet
    , topup_wallet: 'Top Up Wallet'
    , current_balance: 'Current Balance'
    , recommended: 'Recommended'
    , debit_from: 'Debit From'
    , automatically_topup: 'Automatically Top-Up'
    , auto_topup_title: 'Automatically top-up your wallet' 
    , auto_topup_desc_1: 'When the balance fails below'
    , auto_topup_desc_2: 'Add the following amount'
    , reset: 'Reset'

    //Subcriptions
    , auto_renew: 'Auto renewing on'
    , sub_contract_period: 'Contract Period'
    , sub_trial_period: 'Trial period'
    , subscriptions_title: 'Subcriptions'
    , billing_day: 'Billing Day'
    , next_billing_day: 'Next Billing Date'
    , month_title: 'Months'
    , monthly: 'Monthly'
    , state_effective: 'Effective'
    , in_contract: 'In Contract'
    , in_trial: 'In Trial'
    , added_on: 'Added on'
    , active_since: 'Active since'
    , removed_on: 'Removed on'
    , firts_activated_on: 'Firts activated on'
    , recurring_charge: 'Recurring charge'
    , recurring_payment: 'Change payment card'
    , latest_billed_period: 'Latest billed period'
    , devices: 'Devices'
    , on_customer_premises_since:'On customer premises since: '
    , provisions: 'Provisions:'
    , expense_service: 'Expense Services'

    //Service Requests
    , service_requests: 'Service Requests'
    , new_service_request: 'New Service Request'
    , title: 'Title'
    , queue: 'Queue'
    , description: 'Description'
    , add_files: 'Add Files'
    , create: 'Create'
    , classification: 'Classification'
    , closure_reason: 'Closure Reason'
    , response: 'Response'
    , please_chosse_classification: 'Please select classification'
    , create_service_request_success: 'Service Request created successfully'
    , create_service_request_failed: 'Create service request failed'

    //Redeem Pass
    , redeem_pass: 'Redeem A Pass'
    , redeem: 'Redeem'
    , redeem_desc: 'Enter your Pass Code below to redeem your Pass'
    , pass_code: 'Pass Code'
    , pass_pin: 'PIN (if applicable)'
    

    //Online shop
    , address_title: "Address: "
    , location_name: "Location name: "
    , location_not_found: "Location detail not found!"
    , title_notify_not_found: "Notify"
    , online_shop_detail_title: "Location Detail"
    
    //our_partners
    , our_partners: 'Our Partners'

    //Confirm Message 
    , message_bank_card: 'Register one or more Bank card(s) to get awarded for your purchases.'
    , add_a_card_now: 'Add a card now'

    , mobile_pass_card: 'Mobile Pass Card'
    , mobile_pass_card_desc: 'Select one of the options to download the mobile pass card to your phone'
    , add_to_apple_wallet: 'Add to Apple Wallet'
    , add_to_wallet_passes: 'Add to WalletPasses'
    , save_to_phone: 'Save to phone'
    , file_pkpass_not_found: 'PKPass File not found'

    //invoice page
    , invoice_title: 'Invoices'
    , account_balance: 'Account Balance'
    , overdue_amount: 'Overdue Amount'
    , account_finance: 'Account Finance'
    , invoices: 'Invoices'
    , btn_service_changes: 'Service Changes'
    , upgrade_service: 'Upgrade'
    , period_title: 'Specify period'
    , date_title: 'Transaction Date'
    , due_date: 'Due Date'
    , invoice_tax_amount: 'Tax'
    , invoice_net_amount: 'Net'
    , invoice_total_amount: 'Total'
    , unpaid_amount: 'Unpaid Amount'
    , paid_amount: 'Paid Amount'
    , account_title: 'Account'
    , currency_code: 'Currency'
    , invoice: 'Invoice'

    //register existing
    , register_existing_title: 'Registration'
    , contact_code: 'Contact Code'
    , enter_contact_code_placeholder: 'Enter Contact Code'
    , services_title: 'Services'
    , remaining: 'Remaining'
    , remaining_allowance: 'Remaining Allowance'
    , periods_allowance: 'Periods Usage'
    , days: 'days'
    , can_not_find_customer: 'Email address not found'
    , can_not_find_email_customer: 'Can not find email of customer'
    // , upgrade_service_success: 'Upgrade service successfully'
    , upgrade_service_faild: 'Upgrade service failed'
    , upgrade_service_faild_credit_limit: 'Service upgrade failed. Your credit limit has been exceeded. Please contact our Service customer for further assistance'

    , products_tier: 'Service Upgrade'
    
    , from_date: 'From Date'
    , to_date: 'To Date'
    , invoice_number: 'Number'
    , invoice_posted_date: 'Posted Date'
    , invoice_issued_date: 'Issued Date'
    , invoice_due_date: 'Due Date'
    , invoice_overdue_amount: 'Overdue amount'
    , topup_title: 'Top-up'
    , account_management: 'Account Management'
    , my_account_number: 'Account Number'
    , credit_note: 'Credit Note'
    , payment: 'Payment'
    , refund: 'Refund'
    , payout: 'Payout'
    , transfer: 'Transfer'
    , manual_journal: 'Manual Journal'
    , transaction_type: 'Transaction Type'
    , invoice_amount: 'Amount'
    , print_out: 'Print Out'
    , no_available_upgrade_service: 'No service available for upgrade'
    
    , update_subscription_success: 'Update payment card success'
    , update_subscription_faild: 'Update payment card failed'
    , card_is_already_selected: 'The card is already selected'

    , billing_period: 'Billing period'
    , confirm_upgrade: 'Do you want to upgrade to '

    //rules password
    , inform_password: 'The password:'
    , inform_password_1: '1) must be at least 8 characters in length.'
    , inform_password_2: '2) can contain alphanumeric characters'
    , inform_password_3: '3) can contain special characters'
    , inform_password_4: '4) cannot contain a sequence of characters or numbers (e.g. "abcdfg" or "123456")'
    , inform_password_5: '5) cannot be set to a previously used password'

    //management service    
    , confirm_change_service: 'Do you want to change service to '
    , no_available_change_service: 'No available change service'
    , change_service: 'Change Service'
    , upgrade_service_success: 'Service upgraded successfully.'
    , upgrade_service_failed: 'Upgrade service failed.'
    , downgrade_service_success: 'Service downgraded succesfully.'
    , downgrade_service_failed: 'Downgrade service failed.'
    , cancel_service_success: 'Cancel service successfully.'
    , cancel_service_success_with_date: 'Cancellation of Service will be performed on '
    , cancel_service_failed: 'Cancel service failed.'
    , change_service_failed_credit_limit: 'Service upgrade failed. Your credit limit has been exceeded. Please contact our Service customer for further assistance'
    , change_service_failed: 'Change service failed.'
    , change_service_success: 'Change service successfully.'
    , confirm_cancel_service: 'Do you want to cancel service?'
    , confirm_pause_service: 'Do you want to pause service?'
    , pause_service_success: 'Pause service successfully.'
    , pause_service_failed: 'Pause service failed.'
    , btn_pause: 'Pause'
    , btn_resume: 'Resume'
    , btn_active: 'Activate'
    , confirm_resume_service: 'Do you want to resume service?'
    , resume_service_success: 'Resume service successfully.'
    , resume_service_failed: 'Resume service failed.'
    , confirm_active_service: 'Do you want to activate service?'
    , active_service_success: 'Service activated successfully.'
    , active_service_failed: 'Active service failed.'
    , down_service_success: 'Downgrade service successfully.'
    , btn_actions: 'Actions'

    , resume_service_success_with_date: 'Resume of Service will be performed on '
    , pause_service_success_with_date: 'Pause of Service will be performed on '
    , upgrade_service_success_with_date: 'Upgrade of Service will be performed on '
    , down_service_success_with_date: 'Downgrade of Service will be performed on '
    , active_service_success_with_date: 'Activate of Service will be performed on '
    
    , confirm_cancel_service_success_with_date: 'Do you want cancel service to be performed on '
    , confirm_resume_service_success_with_date: 'Do you want resume service to be performed on '
    , confirm_pause_service_success_with_date: 'Do you want pause service to be performed on '
    , confirm_upgrade_service_success_with_date: 'Do you want upgrade service to be performed on '
    , confirm_down_service_success_with_date: 'Do you want downgrade of service to be performed on '
    , confirm_active_service_success_with_date: 'Do you want activate service to be performed on '

    , amount_less_equal_than: 'Amount must be less or equal than '
    , amount_greater_than: 'Amount must be greater than 0!'
    , message_delete_card: 'Are you sure you want to delete this card?'
    
    , english: "English"
    , greek: 'Greek'
    , spend_type_title: 'Spend'
    , award_type_title: 'Award'
    , order_type_title: 'Order'
    , purchase_cancellation: 'Purchase cancellation'



    ////
    , DAYS: {
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday'
    }
    , SHORTDAYS: {
        MONDAY: 'Mon',
        TUESDAY: 'Tue',
        WEDNESDAY: 'Wed',
        THURSDAY: 'Thu',
        FRIDAY: 'Fri',
        SATURDAY: 'Sat',
        SUNDAY: 'Sun'
    }
    , SHORTMONTH: {
        JAN: 'Jan'
        , FEB: 'Feb'
        , MAR: 'Mar'
        , APR: 'Apr'
        , MAY: 'May'
        , JUN: 'Jun'
        , JUL: 'Jul'
        , AUG: 'Aug'
        , SEP: 'Sept'
        , OCT: 'Oct'
        , NOV: 'Nov'
        , DEC: 'Dec'
    }
    , MONTH: {
        JAN: 'January'
        , FEB: 'February'
        , MAR: 'March'
        , APR: 'April'
        , MAY: 'May'
        , JUN: 'June'
        , JUL: 'July'
        , AUG: 'August'
        , SEP: 'September'
        , OCT: 'October'
        , NOV: 'November'
        , DEC: 'December'
    }
    , please_note: 'Please note'
    //Return message
    , ERROR: "Error"
    , SUCCESS: "Success"
    , EXCEPTION: "Exception"
    , EXCEPTION_PROCESS: 'Error processing request.'
    , REGISTRATION_FAIL_CONTACT_EXISTS: 'This email has been registered in the portal. Please sign in.'
    , REGISTRATION_FAIL_CONTACT_EXISTS_EMAIL: 'This email has been registered in the portal. Please sign in.'
    , INVALID_PHONE_LOGIN: 'Sign In failed. Invalid Phone Number.'
    , INVALID_OTP: 'Invalid OTP.'
    , INVALID_EMAIL_LOGIN: 'Sign In failed. Invalid credentials.'
    , PROFILE_UPDATE_SUSCESS: 'Profile updated successfully.'
    , UPDATE_FAIL: 'Error updating profile. Please try again later.'
    , PHONE_NUMBER_ALREADY_EXIST: 'Account already registered. Please contact support.'
    , CHANGE_PASSWORD_SUCCESS: 'Password updated successfully.'
    , CHANGE_PASSWORD_FAIL: 'Error updating password. Please try again later.'
    , GET_CONFIG_FAIL: "System not responding. Please try again later."
    , REGISTER_EMAIL_SUCCESS: "You are almost there. We have sent you an email for verification. Please check and complete your registration"
    , REGISTER_EMAIL_SMS: "Your credential is created successfully. You can now sign in with your email."
    , OTP_RESEND_SUCCESS: "A One-Time-Password has been sent via SMS."
    , OTP_RESEND_EMAIL_SUCCESS: "A One-Time-Password has been sent via Email."
    , access_photos_denied: 'Access to Photos has been prohibited. Please enable it in the phone Settings.'
    , access_camera_denied: 'Access to the camera has been prohibited. Please enable it in the phone Settings.'
    , access_location_denied: 'Access to Location has been prohibited. Please enable it in the phone Settings.'
    , REWARDS_SCHEME_SIGN_UP_SUCCESS: 'You have successfully signed up to '
    , REWARDS_SCHEME_SIGN_UP_FAIL: 'Failed to sign up to scheme '
    , REWARDS_SCHEME_SIGN_OUT_SUCCESS: 'You have successfully signed out'
    , REWARDS_SCHEME_SIGN_OUT_FAIL: 'Failed to sign out '
    , ADD_ADDRESS_SUCCESS: 'Address added successfully.'
    , UPDATE_ADDRESS_SUCCESS: 'Address updated successfully.'
    , REMOVE_ADDRESS_SUCCESS: 'Address deleted successfully.'
    , FAILED_TO_UPDATE_ADDRESS: 'Update address not successful.'
    , FAILED_TO_ADD_ADDRESS: 'Saving new address was not successful.'
    , ADD_ADDRESS_ALREADY_TYPE: 'Saving new Address was not successful. Address with the same type and label already exists.'
    , FAILED_TO_REMOVE_ADDRESS: 'Address deletion not successful'
    , CREATE_REERRAL_SUCCESS: 'Refer a Friend Code successfully entered.'
    , CREATE_REERRAL_FAIL: 'Please check your Refer a Friend code and try again.'
    , ORDER_SELECT_ADDRESS: 'Please select a delivery address.'
    , ORDER_SELECT_STORE: 'Please select location.'
    , DELIVERY_VALIDATION_LOCATION: 'Unfortunately Delivery is not available in your area at the this time.'
    , PICK_UP_VALIDATION_LOCATION: 'Unfortunately, Pick Up is not available for the selected location'
    , DELIVERY_VALIDATION_TIME: 'Unfortunately Delivery is not available at this time.'
    , PICK_UP_VALIDATION_TIME: 'Unfortunately, Pick Up is not available at this time.'
    , FULFILL_ORDER_EMPTY_EXCEPTION:'There are no locations within range that can fulfil your order at this time.'
    , ORDER_VALID_CARD: 'You must add a valid bank card in order to order for Pick Up.'
    , FAILED_TO_REMOVE_CARD: 'Remove card not successful. Please contact support.'
    , REMOVE_CARD_SUCCESS: 'Card removed successfully.'
    , FORGOT_PASSWORD_SUCCESS: 'An email with instructions to reset your password has been sent.'
    , FORGOT_PASSWORD_FAIL: 'Error resetting password. Please try again later.'
    , FORGOT_EMAIL_NOT_FOUND_EXCEPTION: 'Unfortunately, we do not recognise this email address.'
    , CAN_NOT_FULFILL_ORDER_EXCEPTION: 'The selected location cannot fulfill your order at this time.'
    , PHONE_NUMBER_NOT_FOUND: 'Add a phone number in order to proceed.'
    , MINIMUM_ORDER_AMOUNT_NOT_REACHED: "Minimum order amount not reached."
    , invalid_card: "Please provide a valid card."
    , CARD_ALREADY_EXIST: 'Card already exists.'
    , FAILED_TO_ADD_CARD: 'Error adding the new card. Please try again later.'
    , ADD_NEW_CARD_SUCCESS: 'New card added successfully.'
    , UPDATE_SPEND_PREFERENCES_SUCCESS: 'Update successfully'
    , SIGN_UP_ORGANISATION_ALREADY: 'You are already participating in '
    , ADD_FINGERPRINT_FAIL: 'Add fingerprint failed.'
    , SIGN_UP_OFF_ORGANISATION_IS_NOT_ALLOWED: 'Sign up/off to other organisations is not allowed using current access token'
    , CONTACTUNIQUELYIDENTIFYEXCEPTION: "The email is not found. Please register with our call agent for further support."
    , NOTFOUNDEXCEPTION: "Error sending One-Time-Password."
    , EMAIL_NOT_VERIFIED: 'Email address has not been verified. Please resend verification email and follow the instructions to verify your account.'
    , CARD_ALREADY_EXIT:'Card Number {0} already exist.'
    , JAIL_BROKEN_MESSAGE:"Your device is tampered or rooted. The app cannot run."
    , NOT_SUPPORT_REGION: 'We are not supported in your region'
    , RESEND_EMAIL_SUCCESS: "Resend verification email successfully. Please check the link sent to your email and follow the instructions to verify your account."
    , REQUEST_WALLET_FUNDS_AMOUNT_INVALID:'Invalid amount. Amount cannot exceed '
    , INVALID_QRCODE:"Sorry, something went wrong. Please try again."
    , RECEIPT_ALEADY_EXIST:"Sorry, a request for this receipt already exists."
    , RECLAIM_PURCHASE_SUCCESS:'It will take just a moment before awards are shown in your wallet'
    , INVALID_PASSWORD_EXCEPTION:"The password is not in a valid format"
    , PASSWORD_LENGTH_EXCEPTION:'Password must be at least 8 characters long and must not contain sequences (i.e. "123456" or "abcdef")'
    , NAMEDAY_NOT_CONFIG: 'Name Days not configured. Please contact support.'
    , TOPUP_SUCCESS: 'Your Wallet has been topped up successfully'
    , TOPUP_FAILED: 'Wallet top up failed. Your card has not been debited.'
    , PAYMENT_SUCCESS: 'Payment was submitted successfully'
    , PAYMENT_FAILED: 'Payment failed'
    , ADDCARD_SUCCESS: 'Add card successfully'
    , ADDCARD_FAILED: 'Add card failed'
    , WALLET_FUND_INSUFFICIENT:'Insufficient wallet funds'
    , CUSTOMER_EMAIL_ALREADY_EXIST: 'Paypal account already exist'    
    , TOO_MANY_REQUESTS:"Too many requests submitted. Please try again later."
    , TOO_MANY_RECIPIENTS_EXCEPTION:"Only a maximum of ten recipients is allowed"
    , PROMO_CODE_INVALID:"Promo Code incorrect."
    , REDEEM_A_PASS_FAIL:"Pass redemption failed."
    , REDEEM_A_PASS_SUCCESS:"Pass redeemed successfully"
    , REDEEM_PASS_INVALID:"Error redeeming Pass. Invalid Pass Code or mandatory PIN."
    , REDEEM_PASS_USED:"Error redeeming Pass. Pass has already been redeemed or invalid life cycle state."
    , SERVICE_ALREADY_EXIST:"You are trying to order a service which is you are already subscribed to. Please cancel order and try again."

    // New only portal
    , place_an_order: 'Place an order'
    , show_on_map: 'Show on map'
    , merchant_near_you: 'Locations'
    , text_title_to_be_replace: 'Offers'
    , edit_profile: 'Edit Profile'
    , more_info: 'More Info'
    , enter_same_password: 'Passwords do not match'
    , enter_your_otp: 'Enter your OTP'
    , otp_code: 'OTP Code'
    , verify_your_phone_number: 'Verify your phone number'
    , or_sign_in_with: 'Or sign in with'
    , enable_location_permissions: 'Can not get location because not access your location.Please allow location access to use features'
    , load_more: 'Load More'
    // all
    , receive_marketing_information: 'Receive marketing information via:'
    , refer_send_success: 'Friend referral(s) successfully sent'
    , referral_code: 'Referral Code (optional)'
    , CARD_NOT_FOUND: 'You have no card for payment yet. Please add a card'
    , INVALID_CONTACTPASSWORD_EXCEPTION: 'Password must be at least 8 (alphanumeric and/or special) characters in length and cannot not contain a sequence of characters or numbers (e.g. “abcd” or “1234”) or used previously.'
    , CAN_NOT_FIND_CUSTOMER: 'Can not find customer'
}
export default {
    english
}